<template>
  <PageContent>
    <section class="biography">
      <img class="biography-headshot" src="/images/Resized-Samo.jpg" />
      <section class="biography-content">
        <h3>Samo Burja</h3>
        <h4>Founder and President</h4>
        <p>
          Samo Burja is the founder and President of Bismarck Analysis, which
          applies the foundational sociological research that Samo and his team
          have produced over the past decade to deliver unique insights to
          clients about institutional design and strategy. Samo&rsquo;s studies focus
          on the social and material technologies that foster healthy human
          societies with an eye toward understanding and restoring the
          structures that produce functional institutions. He has authored
          numerous
          <a
            href="https://samoburja.com/essays/"
          >
            articles</a
          >
          and papers on his findings. His manuscript, Great Founder Theory, is
          <a
            href="https://samoburja.com/wp-content/uploads/2020/11/Great_Founder_Theory_by_Samo_Burja_2020_Manuscript.pdf"
            >available here</a
          >.
        </p>
        <p>
          Samo is a Senior Research Fellow in Political Science at the Foresight
          Institute and a Research Fellow at the Long Now Foundation. He speaks
          about his work to audiences around the world, including at the World
          Economic Forum at Davos, Y Combinator&rsquo;s YC 120 conference, the Reboot
          American Innovation conference in Washington, D.C., and
          <a
            href="https://samoburja.com/speaking/"
            >elsewhere</a
          >. Samo spends most of his time in California and his native Slovenia.
        </p>
      </section>
    </section>
    <section class="biography">
      <img class="biography-headshot" src="/images/Resized-Ben.jpg" />
      <section class="biography-content">
        <h3>Ben Landau-Taylor</h3>
        <h4>Senior Analyst</h4>
        <p>
          Ben Landau-Taylor is a Senior Analyst at Bismarck Analysis and has led
          scores of investigations into businesses, nonprofits, government
          agencies, and other institutions. His
          <a
            href="http://www.bismarckanalysis.com/Machine_Tools_Case_Study.pdf"
          >
            research</a
          >
          studies industry through the lens of Great Founder Theory. Ben brings
          to Bismarck his deep expertise in economics and psychology, with a
          view toward how these and related disciplines can be applied to
          understanding our contemporary business, technology, and political
          landscapes. Ben&rsquo;s research interests include industrial sovereignty,
          the psychology of key leaders in business and technology, and how
          markets interact with hierarchical power.
        </p>
        <p>
          Ben organizes the Savoy Club, a gathering of intellectuals in San
          Francisco. His essays are available
          <a href="https://benlandautaylor.com/">online</a>.
        </p>
      </section>
    </section>
  </PageContent>
</template>

<script>
import PageContent from "./PageContent.vue";
export default {
  name: "Leadership",
  components: { PageContent },
  beforeCreate() {
    document.title = "Bismarck Analysis | Leadership";
  },
};
</script>

<style scoped>
img {
  width: 220px;
  margin-right: 2em;
  float: left;
}

.biography {
  display: flex;
  flex-wrap: wrap;
}

.biography-headshot {
  min-width: 200px;
  width: 200px;
  max-width: 400px;
  object-fit: contain;
  align-self: flex-start;
  flex: 1 1 auto;
  padding-bottom: 20px;
}

.biography-content {
  flex: 1 1 auto;
  min-width: 300px;
  max-width: max(calc(100% - 250px), 400px);
  padding-bottom: 40px;
}

.biography-content h3 {
  margin-bottom: 0px;
  margin-top: 0px;
}
.biography-content h4 {
  margin-top: 0px;
  padding-bottom: 0.5em;
}
</style>
